import React from 'react';
import { tv } from '@/utils/tv';

const checkbox = tv({
  base: 'flex size-5 cursor-pointer items-center justify-center transition-colors disabled:cursor-not-allowed',
  variants: {
    isRound: { true: 'rounded-full', false: 'rounded-md' },
    checked: { true: '', false: '' },
    disabled: { true: '', false: '' },
  },
  compoundVariants: [
    {
      checked: true,
      disabled: true,
      class: 'bg-primary-disabled text-primary-foreground opacity-60',
    },
    {
      checked: true,
      disabled: false,
      class: 'bg-primary text-primary-foreground',
    },
    {
      checked: false,
      disabled: true,
      class: 'border border-subtle-foreground opacity-50',
    },
    {
      checked: false,
      disabled: false,
      class: 'border border-subtle-foreground',
    },
  ],
});

interface Props {
  checked: boolean;
  label?: string;
  isRound?: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
}

export const Checkbox: React.FC<Props> = ({
  checked,
  label,
  isRound = false,
  onChange,
  disabled = false,
}) => {
  const handleClick = () => {
    onChange(!checked);
  };

  const control = (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      disabled={disabled}
      onClick={handleClick}
      className={checkbox({ isRound, checked, disabled })}
    >
      {checked && (
        <svg viewBox="0 0 16 16" fill="none" className="size-4">
          <path
            d="M3 8 L7 12 L13 4"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </button>
  );

  if (!label) {
    return control;
  }

  return (
    <label className="flex w-fit cursor-pointer items-center gap-2">
      {control}
      <span className="text-subhead-14 text-muted-foreground">{label}</span>
    </label>
  );
};
